import { render, staticRenderFns } from "./zhibiaoconfig.vue?vue&type=template&id=91974d98&scoped=true"
import script from "./zhibiaoconfig.vue?vue&type=script&lang=js"
export * from "./zhibiaoconfig.vue?vue&type=script&lang=js"
import style0 from "./zhibiaoconfig.vue?vue&type=style&index=0&id=91974d98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91974d98",
  null
  
)

export default component.exports